import React, {Component} from 'react';
import Styles from './style.css';
import cx from 'classnames';
import {langRegister} from "../../../services/langRegister";
import {marketRegister} from "../../../services/marketRegister";
import {salesChannelRegister} from "../../../services/salesChannelRegister";
import {dataRegister} from "../../../services/dataRegister";

class HomeSectionsEleven extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: [],
            lockin: false
        };
    };

    componentWillMount() {
        this._updateItems();
    }

    _updateItems() {
        let items = [
            {
                active: false,
                title: "1 " + this._renderText("item_14"),
                multiple: marketRegister.lockin() + " " + this._renderText("item_15"),
                subtitle: marketRegister.lowPlan().short_title.toLowerCase(),
                price: marketRegister.lowPlan().price,
                currency: marketRegister.currency(),
                items: marketRegister.lowPlan().items,
                button: this._renderText("item_8"),
                button_link: false
            },
            {
                active: true,
                title: "1 " + this._renderText("item_14"),
                multiple: marketRegister.lockin() + " " + this._renderText("item_15"),
                subtitle: this._renderText("item_17"),
                price: marketRegister.highPlan().price,
                new_price: marketRegister.lowPlan().price,
                currency: marketRegister.currency(),
                items: marketRegister.highPlan().items,
                button: this._renderText("item_8"),
                button_link: false
            },
            {
                active: false,
                title: "1 " + this._renderText("item_14"),
                multiple: marketRegister.lockin() + " " + this._renderText("item_15"),
                subtitle: marketRegister.masterPlan().short_title,
                price: marketRegister.masterPlan().price,
                new_price: marketRegister.lowPlan().price,
                new_price_color: "black",
                currency: salesChannelRegister.get("currency"),
                items: marketRegister.masterPlan().items,
                button: this._renderText("item_9"),
                button_link: "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/vip"
            },
        ];
        this.setState({items: items});
    }

    _toggleLockin(){
        this.setState({lockin: !this.state.lockin});
    }

    _renderPrice(value){
        if(this.state.lockin){
            return this._renderNumbers((value * (marketRegister.lockin() - marketRegister.discount())));
        }else{
            return value;
        }
    }

    _lisIndustries(){
        if(dataRegister.api.primehit.indexOf("https://api.devprimehit") !== -1){
            window.open("https://app.devadbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/signup/industry", '_blank');
        }else{
            window.open("https://app.adbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/signup/industry", '_blank');
        }
    }

    _renderNumbers(x) {
        try {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return ("...")
        }
    }

    _renderText(item) {
        return langRegister.get("home-sections-eleven", item);
    }

    render() {
        return (
            <div className={Styles.section}>
                <img className={Styles.sectionShadow}
                     src={require("../../../assets/images/CostOpportunity_Angel_Desktop.png")}/>
                <img className={Styles.sectionShadowMobile}
                     src={require("../../../assets/images/CostOpportunity_Angel_Mobile.png")}/>
                <div className={Styles.sectionBackground}>
                    <img className={Styles.sectionBackgroundImage}
                         src={require("../../../assets/images/Wave_Desktop.png")}/>
                    <img className={Styles.sectionBackgroundImageMobile}
                         src={require("../../../assets/images/Wave_Mobile.png")}/>
                </div>
                <div className={Styles.container}>
                    <div className={Styles.title}>
                        <div className={Styles.titleText}>
                            {this._renderText("item_1")}
                            <img className={Styles.bubble} src={require("../../../assets/images/bubble_right.png")}/>
                            <div className={Styles.bubbleText}>
                                {this._renderText("item_2")}
                            </div>
                            <div style={{position: "relative"}}>
                                <img className={Styles.bubbleMobile} src={require("../../../assets/images/AB_bubble_up_mobile.png")}/>
                                <div className={Styles.bubbleTextMobile}>
                                    {this._renderText("item_2")}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={Styles.items}>
                        {
                            this.state.items.map((item) => {
                                return(
                                    <div className={
                                        cx(Styles.item,
                                            {
                                                [Styles.itemGreen]: item.active,
                                            })
                                    }>
                                        <div className={Styles.itemTitle}>
                                            {
                                                !this.state.lockin &&
                                                item.title
                                            }
                                            {
                                                this.state.lockin &&
                                                <span>{item.multiple}</span>
                                            }
                                        </div>
                                        <div className={
                                            cx(Styles.itemSubtitle,
                                                {
                                                    [Styles.itemSubtitleNewPrice]: item.new_price,
                                                })
                                        }>
                                            {item.subtitle}
                                        </div>
                                        {
                                            item.new_price &&
                                            <div className={Styles.itemNewPriceTitle}>
                                                {this._renderText("item_16")}
                                            </div>
                                        }
                                        <div className={
                                            cx(Styles.itemPrice,
                                                {
                                                    [Styles.itemPriceGreen]: item.active,
                                                    [Styles.itemPriceNewPrice]: item.new_price,
                                                })
                                        }>
                                            <div>
                                                <div className={
                                                    cx(Styles.itemPriceCurrency,
                                                        {
                                                            [Styles.itemPriceGreen]: item.active,
                                                        })
                                                }>{item.currency}</div>
                                                {this._renderPrice(item.price)}
                                            </div>
                                            {
                                                item.new_price &&
                                                <div className={
                                                    cx(Styles.itemPriceRemove,
                                                        {
                                                            [Styles.itemPriceRemoveBlack]: item.new_price_color === "black",
                                                        })
                                                }/>
                                            }
                                            {
                                                item.new_price &&
                                                <div>
                                                    <div className={Styles.itemPriceContainer}>
                                                        <div className={
                                                            cx(Styles.itemPriceCurrency,
                                                                {
                                                                    [Styles.itemPriceRed]: true,
                                                                })
                                                        }>{item.currency}</div>
                                                        <div className={Styles.itemPriceNew}>
                                                            {this._renderPrice(item.new_price)}
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        {
                                            item.items.map((item) => {
                                                return(
                                                    <div className={Styles.itemValue}>
                                                        {item.title}
                                                    </div>
                                                )
                                            })
                                        }
                                        <div onClick={() => {
                                            if(item.button_link){
                                                this.props.props.history.push(item.button_link)
                                            }else{
                                                this._lisIndustries()
                                            }
                                        }}  className={
                                            cx(Styles.itemButton,
                                                {
                                                    [Styles.itemButtonGreen]: item.active,
                                                })
                                        } >
                                            {item.button}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={Styles.options}>
                        <div className={Styles.optionsLeft}>
                            {this._renderText("item_3")}
                            <div className={Styles.optionsBold}>
                                {this._renderText("item_4")}
                            </div>
                        </div>
                        <div className={Styles.optionsCenter}>
                            {
                                !this.state.lockin &&
                                <img onClick={() => this._toggleLockin()}
                                     className={Styles.optionsCenterSlider}
                                     src={require("../../../assets/images/push_black_off.svg")}/>
                            }
                            {
                                this.state.lockin &&
                                <img onClick={() => this._toggleLockin()}
                                     className={Styles.optionsCenterSlider}
                                     src={require("../../../assets/images/slider_active.svg")}/>
                            }
                        </div>
                        <div className={Styles.optionsRight}>
                            {this._renderText("item_5")}
                            <div className={Styles.optionsBold}>
                                {this._renderText("item_11")} {(marketRegister.highPlan().price * marketRegister.discount()) + (marketRegister.lowPlan().price * marketRegister.lockin()) - marketRegister.lowPlan().price * marketRegister.discount()} {marketRegister.currency()}
                            </div>
                        </div>
                    </div>
                </div>
                <img className={Styles.sectionShadowBottom}
                     src={require("../../../assets/images/AB_shadow_horisontal.png")}/>
                <img className={Styles.sectionShadowBottomMobile}
                     src={require("../../../assets/images/AB_shadow_horisontal_mobile.png")}/>
            </div>
        );
    }
}

export default HomeSectionsEleven;


// WEBPACK FOOTER //
// ./src/components/home-sections/eleven/component.js